var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#003B6F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13385_5068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3592 14.6662C11.7048 14.6443 11.2113 14.4799 10.7324 14.2534C9.95745 13.8881 9.2702 13.384 8.63047 12.8215C7.76045 12.0543 6.98912 11.2032 6.34208 10.2388C5.96921 9.6799 5.64752 9.09542 5.45743 8.44885C5.33314 8.02145 5.28196 7.58675 5.4026 7.14474C5.47205 6.88903 5.60731 6.67351 5.79375 6.4872C6.17027 6.1146 6.54314 5.73835 6.91601 5.36209C6.95987 5.31825 6.97815 5.32556 7.01836 5.36574C7.78969 6.14017 8.56467 6.91095 9.33966 7.68173C9.38718 7.72921 9.37987 7.75113 9.336 7.79131C8.91561 8.21141 8.49522 8.6315 8.07483 9.04794C8.03461 9.08812 8.02365 9.11369 8.06386 9.16483C8.85712 10.2132 9.74542 11.1703 10.8421 11.9119C10.8969 11.9484 10.9225 11.9484 10.97 11.9009C11.3795 11.4845 11.7962 11.0717 12.2056 10.6552C12.2568 10.6041 12.2824 10.6041 12.3299 10.6552C13.0939 11.4224 13.8616 12.1895 14.6293 12.953C14.6768 13.0004 14.6841 13.026 14.6329 13.0772C14.2747 13.4278 13.9164 13.7822 13.5655 14.1438C13.1963 14.5237 12.7503 14.6735 12.3592 14.6662Z",
    fill: "#003B6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13385_5068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33269,
    height: 9.33333,
    fill: "white",
    transform: "translate(5.33301 5.33325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.fbbf71cd08a306c1068654fb31585b5b.svg";
export { ForwardRef as ReactComponent };